import { lazy } from 'react';

const SupplementalPlanRequirementListDrawer = lazy(
  () =>
    import(
      'modules/CoursePlanner/pages/Summary/components/SupplementalPlanRequirementListDrawer'
    ),
);

export default {
  SUPPLEMENTAL_PLAN_REQUIREMENT_LIST_DRAWER:
    SupplementalPlanRequirementListDrawer,
};
